<template>
  <div class="canvas-container">
    <canvas
      id="whiteboard"
      resize
      :class="cursorProperty "
    />
    <mainPanel @shareBoard="shareBoard" />
    <historyPanel />
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          max-width="400px"
          :overlay-opacity="0"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Share your Board 🌎</span>
            </v-card-title>
            <!-- <v-card-subtitle>
              Make your Board public for realtime collaboration!
            </v-card-subtitle>-->
            <v-card-text>
              <v-container>
                Make your Board public for realtime collaboration!
                <!-- <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      label="Legal first name*"
                      required
                    />
                  </v-col>
                </v-row>-->
              </v-container>
              <!-- <small>*indicates required field</small> -->
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                raised
                color="blue darken-1"
                text
                :loading="boardLoading"
                @click="publishBoard"
              >
                Publish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import paper from 'paper';
import MainPanel from './panel/MainPanel';
import HistoryPanel from './panel/HistoryPanel';

import { mapGetters } from 'vuex'
import get from 'safe-get'

function changeZoom(oldZoom, delta, c, p) {  
        var factor;
        var newZoom;
        factor = 1.05;
        if (delta > 0) {
          newZoom = oldZoom * factor;
        }
        if (delta < 0) {
          newZoom = oldZoom / factor;
        }
        let beta = oldZoom / newZoom;
        p.add(new paper.Point(7.5, 7.5));
        let pc = p.subtract(c);
        let a = p.subtract(pc.multiply(beta)).subtract(c);
        return [newZoom, a];
      }
      
function MouseWheelHandler(e){
    // cross-browser wheel delta
    e = window.event || e; // old IE support
    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
    var mousePosition = new paper.Point(e.offsetX, e.offsetY);
    var viewPosition = paper.view.viewToProject(mousePosition);
    let  _ref1 = changeZoom(paper.view.zoom, delta, paper.view.center, viewPosition);
    var newZoom = _ref1[0];
    var offset = _ref1[1];
    paper.view.zoom = newZoom;         
    paper.view.center = paper.view.center.add(offset);     
    return false;
}

export default {
  components: {
    mainPanel: MainPanel,
    historyPanel: HistoryPanel
  },
  data: function() {
    return {
        dialog: false,
        boardId: null
      };
    },
    
  computed:{
    ...mapGetters([
      'tool',
      'boardLoading',
      'boardLoadError'
    ]),
    // tool: function() {
    //   return this.$store.getters.tool;
    // },
    cursorProperty (){
      //calculate cursor property based on tool
      if(this.tool === 'hand'){
      return 'grab';
      }
      return ''
    }
  },
  created () {
    paper.install(window);
    // eslint-disable-next-line no-console
    
  },
  mounted () {
    

    paper.setup('whiteboard')
    var canvas = document.getElementById('whiteboard')
    if (canvas.addEventListener)
    {
        // IE9, Chrome, Safari, Opera
        canvas.addEventListener('mousewheel', MouseWheelHandler, false);
        // Firefox
        canvas.addEventListener('DOMMouseScroll', MouseWheelHandler, false);
    }
    // IE 6/7/8
    else
    {
        canvas.attachEvent('onmousewheel', MouseWheelHandler);
    }

  },
  destroyed(){
  },
  methods:{
    shareBoard(){
      this.dialog = true
    },
    publishBoard(){
      this.$store.dispatch('publishBoard').then(response => {
        if(response){
          // eslint-disable-next-line no-console
          console.log('Response from Publish Lambda:', response);
          this.boardId = response.data.boardId
          this.$router.push(`/board/${this.boardId}`);
          this.dialog = false
        }
        
      });
    },
    invokeInit(){
      const socketArgs= {
        action:'init',
        boardId: this.$route.params.id
      }
      this.$socket.send(JSON.stringify(socketArgs))
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    if(get(to.params,'id')){
      vm.$connect(`wss://o9mtupxxo4.execute-api.eu-central-1.amazonaws.com/prod?boardId=${to.params.id}`)
      vm.$options.sockets.onopen = () => vm.invokeInit()
    }
  })
  },
  beforeRouteUpdate (to, from, next) {
    if(get(to.params,'id')){
      this.$connect(`wss://o9mtupxxo4.execute-api.eu-central-1.amazonaws.com/prod?boardId=${to.params.id}`)
          this.$options.sockets.onopen = () => this.invokeInit()

    }
    // eslint-disable-next-line no-console
          console.log('Before Route Enter:', to, from, next);
          next()
  },
};
</script>


<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
          height: 100%;

  overflow: hidden;
}
canvas {
  // overflow: -moz-hidden-unscrollable;
  // display: block;
  height: 100vh;
  width: 100%;
  background: #ffffff;
}
.grab {
  cursor: grab;
}
</style>
